import React, { Component } from "react";
import { connect } from "react-redux";

import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import { productItemHistoryModelClose } from "../../store/ServiceRequest/actions";
import moment from "moment";

class ProductHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    console.log("productItemHistory_model",this.props.productItemHistory_model)
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.productItemHistory_model}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader toggle={() => this.props.productItemHistoryModelClose()}>
            Product History
          </ModalHeader>

          <ModalBody>
            <div
              className="table-responsive m-0"
              style={{
                maxHeight: "550px",
                overflowY: "auto",
              }}
            >
              <Table
                // striped
                bordered
                hover
                responsive
                className="mb-0 p-0 table-centered"
              >
                <thead className="bg-light text-center">
                  <tr>
                    <th className="nowrap">S.No</th>
                    <th className="nowrap">Qty / Units</th>
                    <th className="nowrap">location</th>
                    <th className="nowrap">Issue Code</th>
                    <th className="nowrap">Issue Date</th>
                    <th className="nowrap">Issue By</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.productItemLoglist.length === 0 ? (
                    <>
                      <tr>
                        <td colspan="5" className="text-center">
                          <span className="font-size-18 text-danger">
                            Data not available
                          </span>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {this.props.productItemLoglist.map((Item, key) => (
                        <tr key={key}>
                          <td className="text-center">{key + 1}</td>
                          <td className="text-center">
                            {Item.f_qty} {Item?.f_unit.name}
                          </td>
                          <td className="text-center">
                            {Item?.materialissue?.location?.name}
                          </td>
                          <td className="text-center">
                            {
                              Item?.materialissue?.fcode
                              // ? Item.materialissue?.fcode
                              // : "***"
                            }
                          </td>
                          <td className="text-center">
                            {moment(Item?.materialissue?.date).format(
                              "DD-MM-YYYY"
                            )}
                          </td>
                          <td className="text-center">
                            {Item?.materialissue?.createdby?.fullname}
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </Table>
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { productItemHistory_model, productItemLoglist } = state.Servicerequest;
  return {
    productItemHistory_model,
    productItemLoglist,
  };
};

export default connect(mapStatetoProps, {
  productItemHistoryModelClose,
})(ProductHistory);
